import { render } from "./dewas-detail.vue?vue&type=template&id=23ebd292&scoped=true"
import script from "./dewas-detail.vue?vue&type=script&lang=js"
export * from "./dewas-detail.vue?vue&type=script&lang=js"

import "./dewas-detail.vue?vue&type=style&index=0&id=23ebd292&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ebd292"]])

export default __exports__